import { render, staticRenderFns } from "./approvalItemList.vue?vue&type=template&id=58f1ea24&scoped=true&"
import script from "./approvalItemList.vue?vue&type=script&lang=js&"
export * from "./approvalItemList.vue?vue&type=script&lang=js&"
import style0 from "./approvalItemList.vue?vue&type=style&index=0&id=58f1ea24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f1ea24",
  null
  
)

export default component.exports